// This file now simply re-exports the Dashboard page for unified experience
import Dashboard from './Dashboard';
export default Dashboard; 